import { getTrainingData, subscriptionStatus } from "./trainingService";
import { methodSubscribe } from "./trainingService";


export const fetchTraining = async () => {
    try {
        const data = await getTrainingData()


        if (data) {
            //console.log('data training: ', data)



            return { data }


        }
    } catch (error) {
        //console.log('error training: ', error)
    }
}


export const UseGetDataSubscribe = () => {



    const asyncSubscribeData = async () => {
        //console.log('funka')
        try {

            let enrollmentType = {
                "enrollmentType": "TPATraining"
            }

            const response = await methodSubscribe(enrollmentType)

            if (response) {
                //console.log('UseGetDataSubscribe controller: ', response)
                return response
            }

        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    //? habilitar para realizar las peticiones 
    const response = asyncSubscribeData()

    return response
    // const response = {
    //     config: {
    //         transitional: {},
    //         adapter: [null, null, null],
    //         transformRequest: [null],
    //         transformResponse: [null],
    //         timeout: 0
    //     },
    //     data: {
    //         message: "Suscripción enviada exitosamente."
    //     },
    //     headers: {
    //         "cache-control": "no-transform",
    //         "content-type": "application/json; charset=utf-8"
    //     },
    //     request: {
    //         onreadystatechange: null,
    //         readyState: 4,
    //         timeout: 0,
    //         withCredentials: false,
    //         upload: {}
    //     },
    //     status: 200,
    //     statusText: ""
    // };

    // return response



}

export const getUserStatus = async () => {
    try {
        const data = await subscriptionStatus()

        if (data) {

            let newData = data.data.subscriptions
            //console.log('data subs: ', data)
            return newData
        }

    } catch (error) {

    }
}